import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/bin.svg";
var BinSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  BinSolid_default as default
};
